import React from 'react';
import { Coins, Users, Shield, Landmark } from 'lucide-react';
import { formatGold } from '../../utils/goldNotation';

const CARD_CLASS = 'bg-gradient-to-br from-slate-800/80 to-slate-900/80 backdrop-blur-xl rounded-2xl p-5 border border-white/10 shadow-xl flex items-start gap-4';

const SummaryCards = ({ summary }) => {
  const cards = [
    { label: 'Total arrecadado', amount: summary.prizeAmount, hint: `${summary.bcCount} BC(s) no recorte`, icon: Coins, color: 'from-emerald-500 to-green-600' },
    { label: '50% para Players', amount: summary.pilotsShareAmount, hint: 'Dividido entre os beneficiários', icon: Users, color: 'from-cyan-500 to-blue-600' },
    { label: '20% para o Caixa', amount: summary.treasuryAmount, hint: 'Reserva do clã', icon: Landmark, color: 'from-purple-500 to-fuchsia-600' },
    { label: '30% Administrativo', amount: summary.adminCostAmount, hint: 'Custos do clã', icon: Shield, color: 'from-orange-500 to-amber-600' },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map(({ label, amount, hint, icon: Icon, color }) => (
        <div key={label} className={CARD_CLASS}>
          <div className={`p-3 rounded-xl bg-gradient-to-br ${color} shrink-0`}>
            <Icon className="w-6 h-6 text-white" />
          </div>
          <div className="min-w-0">
            <p className="text-gray-400 text-sm">{label}</p>
            <p className="text-2xl font-bold text-white" title={Number(amount).toLocaleString('pt-BR')}>
              {formatGold(amount)}
            </p>
            <p className="text-gray-500 text-xs mt-1">{hint}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;
